import type { SnackSettingsInput } from "@/lib/gql/__generated__/graphql";

import type { DesignSnackSettingsFormModel } from "../type";

type Props = {
	viewModel: DesignSnackSettingsFormModel["ViewModel"];
};

export const viewModelToInput = ({ viewModel }: Props): SnackSettingsInput => {
	const { hotelID, gtmID, subDomain, topPageSnackUUID } = viewModel;

	const input: SnackSettingsInput = {
		hotelID,

		gtmID: gtmID?.value,
		subDomain: subDomain?.value,
		// フォームの変換で null が undefined になる。undefined は API で「変更なし」になるため、解除は null で送る
		topPageSnackUUID: topPageSnackUUID?.value ?? null,
	} satisfies SnackSettingsInput;

	return input;
};
